import AxiosAPI from "./AxiosAPI";

export const fetchOffer = async () => {
  try {
    const response = await AxiosAPI.get(`/offers
      `);
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteOffer = async (offerId) => {
  try {
    const response = await AxiosAPI.delete(`/catalog/offer/${offerId}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const handleAddOffer = async (newOffer) => {
  try {
    const response = await AxiosAPI.post(`/catalog/offer`, newOffer);
    return response;
  } catch (error) {
    throw error;
  }
};

export const handleEditOffer = async (offerId, newOffer) => {
  try {
    const response = await AxiosAPI.put(`/catalog/offer/${offerId}`, newOffer);
    return response;
  } catch (error) {
    throw error;
  }
};



export const fetchCoupon = async (key) => {
  try {
    console.log("key",key);
    const response = await AxiosAPI.get(`/coupanDetails?couponID=${key}`);
    return response;
  } catch (error) {
    throw error;
  }
};


export const handleAddCoupon = async (couponCode) => {
  try {
     const response = await AxiosAPI.post("/crm/coupon",couponCode , {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};